<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Agenda de Citas</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="areaLocal" v-show="pestanaId==0">
            <div class="row">
              <div class="col-12">
                <full-calendar id="calendario_agendar_siccij" :events="eventosFullCalendar" :config="configuracionFullCalendar" ref="calendar" @event-selected="calendarioEventoClic"></full-calendar>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <h5>Nomenclatura</h5>
              </div>              
            </div>
            <div class="row new-row">
              <div class="col-3">
                <ul>
                  <li>AGE: Agendada</li>
                  <li>CON: Concluida</li>
                  <li>CAN: Cancelada</li>
                  <li>SL: Usa Sala Lúdica</li>
                </ul>
              </div>
              <div class="col-7"></div>
              
            </div>
          </div>
          <div class="areaLocal" v-show="pestanaId == 1">
            <div class="row new-row">
              <div class="col-12">
                <CalendarioDeCitas :parametros="parametros_CalendarioDeCitas"
                                   v-on:valorParaElPadreCalendarioDeCitas="validarBloque"
                                   :key="parametros_CalendarioDeCitas.key">
                </CalendarioDeCitas>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2">
                <input type="button" value="Cancelar" class="form-control" @click="cambiarPestana(0);" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade"
             id="modalConfirmacion"
             tabindex="-1"
             role="dialog"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true"
             v-if="citaDictamen!= null">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="tituloModalConfirmacion">No. de Folio de Cita: {{citaId}}</h5>
                <button type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <br />
                <div class="row">
                  <div class="col-3">
                    <b>Evaluado: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.PersonaEvaluada.Nombre}} {{citaDictamen.PersonaEvaluada.ApellidoPaterno}} {{citaDictamen.PersonaEvaluada.ApellidoMaterno}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Fecha: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.FechaCitaString}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Juzgado: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.Dictamen.Expediente.AreaDBPJ.Nombre}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>No. Expediente: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.Dictamen.Expediente.Consecutivo}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Tema a Evaluar: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.TemaEvaluacion.Nombre}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Sala Lúdica: </b>
                  </div>
                  <div class="col-9">
                    <span v-if="citaDictamen.SalaLudicaId">{{citaDictamen.SalaLudica.nombre}}</span>
                    <span v-else>No</span>
                  </div>
                </div>
                <div class="row new-row" v-if="citaDictamen != null && citaDictamen.EstatusCitaId == 1">
                  <div class="col-5">
                    <button class="form-control" @click="mostrarModalFinalizarCita"> <i class="fas fa-check"></i> Concluir Cita</button>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-5">
                    <button class="form-control" @click="mostrarCalendarioReagendamiento"> <i class="fas fa-calendar"></i>Reagendar</button>
                  </div>
                </div>
                <div class="row new-row">
                  <div class="col-5">
                    <button class="form-control" @click="irDetalleDeCita()"> <i class="fas fa-info-circle"></i>Ver Detalle</button>
                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <button type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade"
             id="modalFinalizarCita"
             tabindex="-1"
             role="dialog"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Finalizar Cita</h5>
                <button type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <br />
                <div class="row">
                  <div class="col-8">
                    <h5>Estatus Final de Cita:</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <select class="form-control" v-model="estatusFinalCita">
                      <option value="-1">Seleccione un estatus</option>
                      <option value="2">Concluida</option>
                      <option value="3">Cancelada</option>
                    </select>
                  </div>
                </div>
                <div class="row new-row" v-if="estatusFinalCita == 3">
                  <div class="col-12">
                    <h5>Razón de Cancelamiento:</h5>
                  </div>
                </div>
                <div class="row" v-if="estatusFinalCita == 3">
                  <div class="col-12">
                    <input type="text" class="form-control" v-model="razonCancelacion" />
                  </div>
                </div>



              </div>
              <div class="modal-footer">
                <button type="button"
                        class="btn btn-primary"
                        data-dismiss="modal" @click="finalizarCita" :disabled="deshabilitarBotonFinalizar">
                  Aceptar
                </button>
                <button type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade"
             id="modalReagendarCita"
             tabindex="-1"
             role="dialog"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Reagendar Cita</h5>
                <button type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <br />
                <div class="row">
                  <div class="col-8">
                    <h5>Fecha:</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <input type="date" class="form-control" v-model="fechaReagendamiento" />
                  </div>
                </div>
                <div class="row new-row">
                  <div class="col-12">
                    <h5>Hora:</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <input type="time" class="form-control" v-model="horaReagendamiento" />
                  </div>
                </div>
                <div class="row new-row">
                  <div class="col-12">
                    <h5>Razón de Reagendamiento:</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <select class="form-control" v-model="razonReagendamientoId">
                      <option value="-1">Seleccione una razón</option>
                      <option value="1">Inasistencia</option>
                      <option value="2">Indisponibilidad del Psicólogo</option>
                    </select>
                  </div>
                </div>
                <div class="row new-row">
                  <div class="col-12">
                    <h5>Duración:</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <input type="number" min="0" class="form-control" v-model="duracionReagendamiento" />
                  </div>
                </div>
                <div class="row new-row">
                  <div class="col-12">
                    <h5>Sala Lúdica:</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <C013SalasLudicas v-on:valorParaElPadre="cambioSalaLudica"
                                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                      :tipo="enumeraciones.tiposDeSelect.Ninguna"
                                      :idDelInput="'catalogoSalaLudica'"
                                      :parametros="parametros_SalaLudica"
                                      :valorDefinido="parametros_SalaLudica.ValorDefinido"
                                      :key="parametros_SalaLudica.key">
                    </C013SalasLudicas>
                  </div>
                </div>


              </div>
              <div class="modal-footer">
                <button type="button"
                        class="btn btn-primary"
                        data-dismiss="modal" @click="reagendarCita" :disabled="deshabilitarBotonReagendar">
                  Aceptar
                </button>
                <button type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import FullCalendar from '@/../static/js/fullcalendar'
  import CalendarioDeCitas from '@/components/SIPSIC/Dictamenes/ControlDeDictamenes/CalendarioDeCitas.vue'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        nombreEvaluado: "",
        fechaCita: null,
        citaId: 0,
        citaDictamen: null,
        eventosFullCalendar: [],
        estatusFinalCita: -1,
        razonCancelacion: "",
        pestanaId: 0,
        parametros_CalendarioDeCitas: { FiltrarPorPsicologo: true, key: 0 },
        parametros_SalaLudica: {
          ValorDefinido: -2,
          SalaLudicaId: -2,
          key: 0,
          fechaCita: null
        },
        habilitarSala: true,
        fechaReagendamiento: null,
        horaReagendamiento: null,
        usaSalaReagendamiento: false,
        duracionReagendamiento: 0,
        razonReagendamientoId: -1,
        configuracionFullCalendar: {
          slotLabelFormat: 'hh:mma',
          header: {
            left: 'prev,today,next',
            center: 'title',
            right: 'month,agendaWeek,agendaDay'
          },
          defaultView: 'agendaWeek',
          editable: false,
          businessHours: {
            daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
            start: '08:00:00', // a start time (10am in this example)  parametros.horarioAtencionInicio
            end: '16:00:00', // an end time (6pm in this example) parametros.horarioAtencionFinal
          },
          defaultDate: moment().add(1, 'days').format('YYYY-MM-DD'),
          selectConstraint: "businessHours",
          weekends: false,
          minTime: '08:00',
          maxTime: '16:00',
          allDaySlot: false,
          defaultTimedEventDuration: '00:15:00',
          slotDuration: '00:15:00',
          slotLabelInterval: "01:00",
          selectable: false,
          height: 1500,
          contentHeight: 'auto',
          displayEventTime: false

        }
      }
    },
    components: {
      FullCalendar,
      CalendarioDeCitas,
      C013SalasLudicas: catalogos.SIPSIC.C013SalasLudicas,
    },
    methods: {
      calendarioEventoClic: function (event, jsEvent, view) {
        console.log(event)
        this.nombreEvaluado = event.title;
        this.citaId = event.id;
        this.fechaCita = event.description;
        this.citaDictamen = event.CitaDeDictamen;
        this.$forceUpdate();
        this.$nextTick(() => {
          $('#modalConfirmacion').modal('toggle');
        })
      },
      obtenerCitasAgenda: function () {
        var peticion = {
          "esPrueba": false
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetCitasAgenda, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.eventosFullCalendar = response.data.AgendaEventosBloques;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      concluirCita: function (citaId, estatusCitaId) {
        var peticion = {
          "esPrueba": false,
          "CitaDeDictamenId": citaId,
          "EstatusCitaId": estatusCitaId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.CambiarEstatusCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            $('#modalConfirmacion').modal('toggle');
            this.obtenerCitasAgenda();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      reagendarCita: function () {
        const salaLudicaId = (this.parametros_SalaLudica.SalaLudicaId > 0) ? this.parametros_SalaLudica.SalaLudicaId : null;
        var peticion = {
          "CitaId": this.citaId,
          "FechaReagendamiento": this.fechaReagendamiento,
          "HoraReagendamiento": this.horaReagendamiento,
          "UsaSala": false,
          "SalaLudicaId": salaLudicaId,
          "Duracion": this.duracionReagendamiento,
          "RazonReagendamientoId": this.razonReagendamientoId
        };
        console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ReagendarCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.obtenerCitasAgenda();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
            }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      mostrarModalFinalizarCita: function (citaId) {
        this.resetearValoresFinalizarCita();
        this.CitaId = citaId;
        $('#modalFinalizarCita').modal('toggle');
      },
      finalizarCita: function () {
        var peticion = {
          "CitaDeDictamenId": this.citaId,
          "EsPrueba": false,
          "EstatusCitaId": this.estatusFinalCita,
          "MotivoCancelacion": this.razonCancelacion
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.CambiarEstatusCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
            this.obtenerCitasAgenda();
            $('#modalConfirmacion').modal('toggle');
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      cambioSalaLudica(datos) { //Administra los cambios en el componente de TipoPlantilla
        catalogos
        //console.log(datos);
        this.parametros_SalaLudica.SalaLudicaId = parseInt(datos[0].target.value);
      },
      mostrarCalendarioReagendamiento: function () {
        $('#modalConfirmacion').modal('toggle');
        this.parametros_CalendarioDeCitas.key = this.citaId;
        this.cambiarPestana(1);
      },
      cambiarPestana: function (pestana) {        
        this.pestanaId = pestana
      },
      validarBloque: function (datos) {
        if (datos.title.includes("Disponible")) {
          if (datos.title.includes("Inhábil")) {
          bootbox.dialog({
                  title: 'Mensaje del sistema',
                  message: '¿Seguro que desea agendar en un día inhábil?',
                  size: 'medium',
                  buttons: {
                    aceptar: {
                      label: "Aceptar",
                      className: 'btn btn-primary',
                      callback: () => {
                        this.obtenerFechaHora(datos);
                      }
                    },
                    cancelar: {
                      label: "Cancelar",
                      className: 'btn btn-primary',
                      callback: () => {
                      }
                    }
                  }
                });
          }
          else{
            this.obtenerFechaHora(datos);
          }
        } else {
          comun.mensajeDeAlerta("Horario no válido.", null, null)
        }

      },
      obtenerFechaHora: function(datos){
        this.fechaReagendamiento = datos.start.format("YYYY-MM-DD");
          this.horaReagendamiento = datos.start.format("HH:mm:ss");
          this.usaSala = false;
          this.habilitarSala = !datos.title.includes("(Sala Lúdica)")
          this.pestanaId = 0;
          this.parametros_SalaLudica.fechaCita = this.fechaReagendamiento + " " + this.horaReagendamiento
          this.parametros_SalaLudica.key++;
          this.$forceUpdate();
          this.mostrarModalReagendamiento();
      }, mostrarModalReagendamiento: function () {
        $('#modalReagendarCita').modal('toggle');
      },
      irDetalleDeCita: function () {
        $('#modalConfirmacion').modal('toggle');
        //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
        this.$router.push({
          name: "DetalleDeCitaDeDictamen",
          params: { citaId: this.citaId }
        });
      },
      resetearValoresFinalizarCita: function () {
        this.estatusFinalCita = -1;
        this.razonCancelacion = "";
      }

    }, computed: {
      deshabilitarBotonFinalizar: function () {
        return this.estatusFinalCita == -1 || (this.estatusFinalCita == 3 && this.razonCancelacion == "")
      },
      deshabilitarBotonReagendar: function () {
        return this.fechaReagendamiento == "" || this.horaReagendamiento == "" || this.duracionReagendamiento <= 0 || this.razonReagendamientoId == -1
      }
    }, mounted: function mounted() {
      this.obtenerCitasAgenda();
    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
</style>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_agendar_siccij .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-axis {
    background-color: #504f54;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_agendar_siccij .fc-day-header {
    background-color: #212529 !important;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_agendar_siccij .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_agendar_siccij .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_agendar_siccij .fc-button:focus {
    outline: none !important;
  }

  #calendario_agendar_siccij .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: white !important;
  }

  #calendario_agendar_siccij .fc-day-number {
    color: white !important;
  }

  #calendario_agendar_siccij .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 0.85em;
    border-radius: .25rem !important;
    width: 80% !important;
    text-align: center !important;
    margin: auto !important;
  }
  .areaLocal{
  background-color: var(--verde-pj-100);
  box-shadow: 0px 6px 20px 4px #161616;
  padding: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/AgendaDeCitas/AgendaDeCitas.vue